module.exports = __webpack_public_path__ + "static/Mauer2.3ca15791.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/Mauer2.png
// module id = 430
// module chunks = 35783957827783